import React, { useEffect, useState } from "react";
import "./Success.css";
import { useNavigate } from "react-router-dom";

function Success() {
  const navigate = useNavigate();
  const advertiserID = localStorage.getItem("advertiserId");
  const agentVendorType = localStorage.getItem("agentVendorType");
  const token = localStorage.getItem("token");
  const handleBack = () => {
    if (isAdv) {
      navigate("/advertiser-auth/manage-ads");
    } else {
      if(agentVendorType === "Showing Agent"){
        navigate("/agent-auth/showing-leads");
      }
      if(agentVendorType === "Listing Agent"){
        navigate("/agent-auth/listing-leads");
      }
      if(agentVendorType === "Transaction Coordinator"){
        navigate("/agent-auth/tc-leads");
      }
      
    }
  };

  const [isAdv, setIsAdv] = useState(false);

  useEffect(() => {
    if (token) {
      if (advertiserID) {
        setIsAdv(true);
      }
    }
  }, [isAdv]);

  return (
    <div className="success-page">
      <div className="container success-page-container">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <img src="/img/success-image.svg" className="img-fluid" alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center mt-4">
            <h2 className="success-heading">Thank You</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <p className="success-span">
              {isAdv ? (
                <>
                  Your payment has been successfully processed. You can now
                  go to the Manage Ads section on your dashboard.
                  We appreciate your business!
                </>
              ) : (
                <>
                  Your payment has been successfully processed. You can now view
                  and manage the lead/s in the "Manage Leads" section.
                </>
              )}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <button onClick={handleBack} className="btn agent-register-button">
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Success;
